import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, BehaviorSubject, timer } from 'rxjs';
import { finalize, tap, debounceTime } from 'rxjs/operators';

@Injectable()
export class LoadingIndicatorInterceptor implements HttpInterceptor {
  public static loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private inFlightRequests = 0;
  private allowedDomains: string[] = [
    'https://dev.api.vmo2digital.co.uk',
    'https://stg.api.vmo2digital.co.uk',
    'https://api.vmo2digital.co.uk',
    /*
    'https://ct.int.virginmedia.com/graphql',
    'https://ct.stage.virginmedia.com/graphql',
    'https://ct.dev.virginmediao2.co.uk/graphql',
    'https://ct.int.virginmediao2.co.uk/graphql',
    'https://ct.stage.virginmediao2.co.uk/graphql',
    'https://ct.virginmediao2.co.uk/graphql',
    */
    'https://dev.ctassets.virginmedia.com',
    'https://prod.ctassets.virginmedia.com',
  ];
  private ignoredEndpoints: string[] = [
    'account/find-by-address',
    'session-data',
    'account/manage-transaction-data/create',
  ];
  private delayBeforeShowing = 500;
  private minDisplayTime = 1000;
  private hideLoadingTimeout: any | null = null;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAllowedDomain = this.allowedDomains.some((domain) => req.url.startsWith(domain));
    const isIgnoredEndpoint = this.ignoredEndpoints.some((endpoint) => req.url.endsWith(endpoint));

    if (!isAllowedDomain || isIgnoredEndpoint) {
      return next.handle(req);
    }

    if (this.inFlightRequests === 0) {
      timer(this.delayBeforeShowing)
        .pipe(debounceTime(this.minDisplayTime))
        .subscribe(() => {
          LoadingIndicatorInterceptor.loading$.next(true);
        });
    }
    this.inFlightRequests++;
    return next.handle(req).pipe(
      tap(() => {
        if (this.inFlightRequests > 0) {
          this.inFlightRequests--;
        }
      }),
      finalize(() => {
        if (this.inFlightRequests === 0) {
          if (this.hideLoadingTimeout) {
            clearTimeout(this.hideLoadingTimeout);
          }
          this.hideLoadingTimeout = setTimeout(() => {
            LoadingIndicatorInterceptor.loading$.next(false);
            this.hideLoadingTimeout = null;
          }, this.minDisplayTime);
        }
      })
    );
  }
}
